import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../environments/environment';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { LeaseCardInterface } from '../app/interface/leasecard'
import { CognitoUtil } from './cognito.service';
import { map, catchError } from 'rxjs/operators';
import { HoaDocument } from 'app/models/HOA/hoa-document';
import { HoaDocument as HoaDocumentDTO } from 'app/models/HOA/DTO/hoa-document';

@Injectable()
export class LeaseService {
  public static _API_ENDPOINT = environment.apiEndPoint;

  constructor(private http: HttpClient, private router: Router, private cognitoUtil: CognitoUtil) { }

  createLeaseDocumentOptions() {
    this.cognitoUtil.refresh();
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': localStorage.getItem('AWSCreds'),
        'Identity': localStorage.getItem('CognitoId'),
        'Sub': localStorage.getItem('CognitoSub')
      }),
      responseType: 'text' as const
    };
  }

  getHoaDocuments(rentalLeaseKey: number) {
    return this.http.get<HoaDocumentDTO[]>(environment.apiEndPoint + `lease/${rentalLeaseKey}/hoa/documents`, this.cognitoUtil.createOptions())
    .pipe(
      catchError(this.processError),
      map((res) => (<HoaDocumentDTO[]>res).map(x => new HoaDocument(x.Title, x.HoaName, x.Date, x.Url)))
    );
  }

  async processError(err: HttpErrorResponse) {
    throw new Error(err.error);
  }

  getLeasesForDashboard() {
    return this.http.get<LeaseCardInterface[]>(LeaseService._API_ENDPOINT + 'Lease/GetLeasesForDashboard', this.cognitoUtil.createOptions())
      .pipe(
        catchError(this.handleError),
        map((response) => <LeaseCardInterface[]>(response))
      );
  }

  getLeaseDocument(rentalLeaseKey: number) {
    return this.http.get(LeaseService._API_ENDPOINT + 'Lease/GetLeaseDocument?rentalLeaseKey=' + rentalLeaseKey, this.createLeaseDocumentOptions());
  }

  handleError(error: HttpErrorResponse | any) {
    let errMsg: string;
    if (error.status === 403) {
      this.router.navigate(['/logout']);
    }
    if (error.error instanceof ErrorEvent) {
      const body = error.error;
      if (body.message) {
        errMsg = error.error.message;
      } else {
        const err = body;
        errMsg = `${error.statusText || ''} ${err}`;
      }
    } else {
      errMsg = error.message ? error.message : error.toString();
      if (errMsg.length === 0) {
        errMsg = 'There was an unknown error.  Please try again later';
      }
    }

    return errMsg;
  }
}